/**
 * 设置相关的常量都统一定义到这里
 * */

import app from '@/AppData'

/** 默认温柔女声ID */
const DEFAULT_ROLE_ID = 0
/** 商务男声ID */
const BUSINESS_ROLE_ID = 1
/** 活泼女声ID */
const LIVE_ROLE_ID = 2

function getVoiceRoleName (id) {
  if (id == BUSINESS_ROLE_ID) {
    return '商务男声'
  } else if (id == LIVE_ROLE_ID) {
    return '活泼女声'
  }
  return '温柔女声'
}

function getPrologueChecked () {
  let defaultChecked = false
  let businessChecked = false
  let customChecked = false
  if (!app.isVip()) {
    defaultChecked = true
  } else {
    let firstTalk = app.getData().userCustomContent.firstTalk
    console.log('data() firstTalk:' + firstTalk)
    if (!firstTalk) {
      defaultChecked = true
    } else if (firstTalk == '您好，我是机主的助理，他现在在忙，不方便接电话，请问您是哪位？') {
      businessChecked = true
    } else {
      customChecked = true
    }
  }
  return {
    defaultChecked: defaultChecked,
    businessChecked: businessChecked,
    customChecked: customChecked
  }
}

function getPrologueName () {
  let obj = getPrologueChecked()
  if (obj.businessChecked) {
    return '商务版'
  } else if (obj.customChecked) {
    return '自定义'
  } else {
    return '默认版'
  }
}

const SCENE_KEY = {
  EXPRESS: '快递派送已知快递公司',
  TAKEOUT: '外卖配送',
  COURSE: '课程推销_end',
  HUNTING: '招聘猎头_end',
  LOAN: '贷款中介_end',
  FINANCE: '理财推销_end',
  INSURANCE: '保险推销_end',
  HOUSE: '房产中介_end'
}

/**
 * 谢绝场景回复内容
 */
const REFUSE_REPLY = '不需要，谢谢'

export default {
  DEFAULT_ROLE_ID,
  BUSINESS_ROLE_ID,
  LIVE_ROLE_ID,
  getVoiceRoleName,
  getPrologueChecked,
  getPrologueName,
  SCENE_KEY,
  REFUSE_REPLY
}



// WEBPACK FOOTER //
// ./src/components/setting/Constants.js